import React from 'react';

const TimeSlotGrid = ({ slots, bookedSlots, onSelect }) => {
    return (
        <div className="h-[250px] overflow-y-auto flex flex-col gap-2 pr-1">
            {slots.map((time) => {
                const isBooked = bookedSlots.includes(time);
                return (
                    <button
                        key={time}
                        onClick={() => !isBooked && onSelect(time)}
                        disabled={isBooked}
                        className={`w-full text-left px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 border ${
                            isBooked
                                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                : 'bg-white hover:bg-blue-100 text-blue-600 border-blue-200'
                        }`}
                    >
                        {time}
                    </button>
                );
            })}
        </div>
    );
};

export default TimeSlotGrid;